import React from 'react';
import { useNavigate } from 'react-router-dom';
import EduPortalLogo from './EduPortalLogo';

export default function Footer() {
  const navigate = useNavigate();

  const handleScroll = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      const topOffset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - topOffset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    }
  };

  return (
    <footer className="bg-slate-950 text-slate-400 text-sm border-t border-white/10 pt-16 pb-12 relative overflow-hidden font-sora">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 pb-12 border-b border-white/10">
          {/* Brand Col */}
          <div className="lg:col-span-2 space-y-4">
            <EduPortalLogo size="md" />
            <p className="text-slate-400 text-xs sm:text-sm leading-relaxed max-w-sm">
              EduPortal connects administrators, teachers, students, and parents in one modern school management platform for attendance, assessments, coursework, and performance reporting.
            </p>
            <div className="text-xs text-slate-400">
              © {new Date().getFullYear()} EduPortal. All rights reserved.
            </div>
          </div>

          {/* Product Links */}
          <div className="space-y-3">
            <div className="text-xs font-bold uppercase tracking-wider text-slate-200">
              Product
            </div>
            <ul className="space-y-2 text-xs">
              <li>
                <a href="#features" onClick={(e) => handleScroll(e, '#features')} className="hover:text-white transition-colors">
                  Features & Bento
                </a>
              </li>
              <li>
                <a href="#solutions" onClick={(e) => handleScroll(e, '#solutions')} className="hover:text-white transition-colors">
                  Platform Capabilities
                </a>
              </li>
              <li>
                <a href="#how-it-works" onClick={(e) => handleScroll(e, '#how-it-works')} className="hover:text-white transition-colors">
                  How It Works
                </a>
              </li>
              <li>
                <a href="#benefits" onClick={(e) => handleScroll(e, '#benefits')} className="hover:text-white transition-colors">
                  Role Benefits
                </a>
              </li>
            </ul>
          </div>

          {/* Role Login Links */}
          <div className="space-y-3">
            <div className="text-xs font-bold uppercase tracking-wider text-slate-200">
              Role Access
            </div>
            <ul className="space-y-2 text-xs">
              <li>
                <button onClick={() => navigate('/login/admin')} className="hover:text-blue-400 transition-colors text-left">
                  Admin Dashboard
                </button>
              </li>
              <li>
                <button onClick={() => navigate('/login/teacher')} className="hover:text-emerald-400 transition-colors text-left">
                  Teacher Workspace
                </button>
              </li>
              <li>
                <button onClick={() => navigate('/login/student')} className="hover:text-purple-400 transition-colors text-left">
                  Student Portal
                </button>
              </li>
              <li>
                <button onClick={() => navigate('/login/parent')} className="hover:text-amber-400 transition-colors text-left">
                  Parent Workspace
                </button>
              </li>
            </ul>
          </div>

          {/* Account Actions */}
          <div className="space-y-3">
            <div className="text-xs font-bold uppercase tracking-wider text-slate-200">
              Get Started
            </div>
            <p className="text-xs text-slate-400">
              Select your role to sign in to your school workspace.
            </p>
            <div className="pt-2 flex flex-col gap-2">
              <button
                onClick={() => navigate('/select-role')}
                className="w-full text-center py-2.5 px-4 font-bold text-xs text-white bg-blue-600 hover:bg-blue-500 rounded-xl transition-all shadow-md"
              >
                Role Selection
              </button>
              <button
                onClick={() => navigate('/select-role')}
                className="w-full text-center py-2 px-4 font-semibold text-xs text-slate-300 hover:text-white bg-white/5 border border-white/10 rounded-xl transition-all"
              >
                Sign In
              </button>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 flex flex-col sm:flex-row items-center justify-between text-xs text-slate-400 gap-4">
          <div>
            EduPortal — Modern School Management Platform
          </div>
          <div className="flex items-center gap-6">
            <button onClick={() => navigate('/select-role')} className="hover:text-slate-300 transition-colors">
              Platform Status
            </button>
            <button onClick={() => navigate('/select-role')} className="hover:text-slate-300 transition-colors">
              Role Access
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}
